export default __webpack_public_path__ + "static/photo-6b999a42fbce8d34f167b6698f8d1b2b.jpg";